import { NOT_APPLICABLE, UNASSIGNED } from '@/data/constants/gtm';
import { HomeDeliveryDateState } from '@/data/Content/HomeDeliveryDate';
import { PickupDateState } from '@/data/Content/PickupDate';
import { getDaysDifference } from 'presentation/events/utils/ga4Utils';

export const getEddDaysValue = (state: HomeDeliveryDateState | PickupDateState): string => {
	if (state.status === 'available-no-date') return UNASSIGNED;
	if (state.status === 'same-day') return '0';
	if (state.status !== 'with-date') return NOT_APPLICABLE;
	if (state.descriptor === 'today') return '0';
	if (state.descriptor === 'tomorrow') return '1';

	const today = new Date();
	today.setHours(0, 0, 0, 0);
	const days = getDaysDifference(today, state.deliveryDate);
	return days === null ? NOT_APPLICABLE : String(days);
};
